'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dDashboard$002dLogins$002dResponse from "./presto.types$-Dashboard-Logins-Response.js";
var $p;
/** @constructor */
function $c_Lpresto_types$DashboardLoginsResponse$() {
}
export { $c_Lpresto_types$DashboardLoginsResponse$ as $c_Lpresto_types$DashboardLoginsResponse$ };
$p = $c_Lpresto_types$DashboardLoginsResponse$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$DashboardLoginsResponse$;
/** @constructor */
function $h_Lpresto_types$DashboardLoginsResponse$() {
}
export { $h_Lpresto_types$DashboardLoginsResponse$ as $h_Lpresto_types$DashboardLoginsResponse$ };
$h_Lpresto_types$DashboardLoginsResponse$.prototype = $p;
$p.l = (function() {
  return "DashboardLoginsResponse";
});
$p.cFR = (function(x$0) {
  return new $j_presto$002etypes$0024$002dDashboard$002dLogins$002dResponse.$c_Lpresto_types$DashboardLoginsResponse((x$0.j(0) | 0), (x$0.j(1) | 0), (+x$0.j(2)), x$0.j(3), x$0.j(4), x$0.j(5), x$0.j(6), x$0.j(7), x$0.j(8));
});
var $d_Lpresto_types$DashboardLoginsResponse$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$DashboardLoginsResponse$, "presto.types$DashboardLoginsResponse$", ({
  ZA: 1,
  e: 1,
  g: 1
}));
export { $d_Lpresto_types$DashboardLoginsResponse$ as $d_Lpresto_types$DashboardLoginsResponse$ };
var $n_Lpresto_types$DashboardLoginsResponse$;
function $m_Lpresto_types$DashboardLoginsResponse$() {
  if ((!$n_Lpresto_types$DashboardLoginsResponse$)) {
    $n_Lpresto_types$DashboardLoginsResponse$ = new $c_Lpresto_types$DashboardLoginsResponse$();
  }
  return $n_Lpresto_types$DashboardLoginsResponse$;
}
export { $m_Lpresto_types$DashboardLoginsResponse$ as $m_Lpresto_types$DashboardLoginsResponse$ };
//# sourceMappingURL=presto.types$-Dashboard-Logins-Response$.js.map
